import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: 'https://apiv2.staging.whooshing.xyz/api/v2',

  // v1 api
  // baseURL: 'https://staging.whooshing.xyz/api/v1',
  // baseURL: 'https://api.main.whooshing.xyz/api/v1',  //'https://api.whoosh.com.ng/api/v1',
  // baseURL: 'http://127.0.0.1:8000/api/v1',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
})

export default instance
